import React from 'react';
import CategoryLandingPage from './CategoryLandingPage';
import { comedyConfig } from '../configs/categoryLandings';

export default function ComedyLandingPage() {
  return <CategoryLandingPage config={comedyConfig} />;
}
